/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-31 10:21:40
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { RELEASE_0423_DAY } from 'src/constants/campaigns.js';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { allowUsingNewSearchSettings } from 'src/helpers/search-settings-helper';
import TryNewVersion from 'src/components/containers/common/switchNewVersion/search/try-new-version';
import UpgradingBanner from 'src/components/containers/common/switchNewVersion/search/upgrading-banner';
import UpgradedSuccessfullyBanner from 'src/components/containers/common/switchNewVersion/search/upgraded-successfully-banner';
import WarningBannerUpgrade from 'src/components/containers/common/switchNewVersion/search/banner-warning-upgrade';
import * as commonActions from 'actions/common-actions';
import * as merchandisingV2Actions from 'src/stores/actions/merchandising-v2-actions';

type Props = {
  active: boolean,
  loading: boolean,
  handleSwitch: Function,
  handleCancel: Function
};

type ComposedProps = Props & WithI18nProps;

class BannersNewSearchVersion extends Component<ComposedProps> {
  componentDidMount() {
    const { getStatusMigrate } = this.props;
    getStatusMigrate();
  }

  componentWillReceiveProps(nextProps) {
    const { migrateStatus = '', getStatusMigrate, gettingStatusMigrate, isNewSearch } = nextProps;
    if (gettingStatusMigrate === false && this.props.gettingStatusMigrate === true) {
      if (
        migrateStatus === 'running' ||
        (this.props.migrateStatus !== 'running' && migrateStatus === 'undetermined' && !isNewSearch)
      ) {
        clearTimeout(this.timeOutGetStatus);
        this.timeOutGetStatus = setTimeout(() => {
          getStatusMigrate();
        }, 3000);
      }
    }
  }

  render() {
    const {
      enableAISearch,
      migrateStatus,
      isNewSearch,
      migrateNewFeatureV2,
      enableMerchandisingV2,
      getStatusMigrate,
      recentInstalledAt
    } = this.props;

    const isOldUser = moment(new Date(recentInstalledAt * 1000)).isBefore(
      new Date(RELEASE_0423_DAY)
    );

    if (enableAISearch && !isNewSearch)
      return (
        <WarningBannerUpgrade
          migrateStatus={migrateStatus}
          migrateNewFeatureV2={migrateNewFeatureV2}
          getStatusMigrate={getStatusMigrate}
        />
      );
    return (
      <>
        {/* Migrate new search */}
        {(!migrateStatus || !['running', 'done'].includes(migrateStatus)) && !isNewSearch && (
          <TryNewVersion
            migrateNewFeatureV2={migrateNewFeatureV2}
            enableMerchandisingV2={enableMerchandisingV2}
            getStatusMigrate={getStatusMigrate}
          />
        )}
        {migrateStatus && migrateStatus === 'running' && !isNewSearch && <UpgradingBanner />}
        {(migrateStatus === 'done' || isNewSearch) && isOldUser && <UpgradedSuccessfullyBanner />}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  migrateNewFeatureV2: () => dispatch(commonActions.migrateNewFeatureV2(ownProps.i18n)),
  enableMerchandisingV2: enable =>
    dispatch(merchandisingV2Actions.enableMerchandisingV2(enable, ownProps.i18n)),
  getStatusMigrate: () => dispatch(commonActions.getStatusMigrate(ownProps.i18n))
});

const mapStateToProps = (state, props) => {
  const searchVersion = _.get(state.oauth, 'tenantApp.parseParams.searchVersion', '1.0');
  const isNewSearch = allowUsingNewSearchSettings(searchVersion);
  const tenantId = _.get(state.oauth, 'tenantApp.tenantId', '');
  const recentInstalledAt = _.get(state.oauth, 'tenantApp.recentInstalledAt', '');

  return {
    tenantId,
    recentInstalledAt,
    isNewSearch,
    migrateStatus: _.get(state.common, 'status', null),
    gettingStatusMigrate: _.get(state.common, 'loading', null),
    enableAISearch: _.get(
      state.oauth.tenantApp,
      'settings.instantSearch.settings.AI-synonyms',
      false
    )
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(BannersNewSearchVersion));
